// Сущность «город / аэропорт»: подсказка для поля «Откуда / Куда»
import type { Place } from '@sayohat/shared';
import type { AutocompleteItem } from '../../shared/ui/Autocomplete';

/** Подсказка формы поиска: город, страна, код */
export function placeItem(p: Place): AutocompleteItem {
  return {
    label: `${p.name} (${p.code})`,
    value: p.code,
    node: (
      <>
        <span>{p.name}{p.type === 'airport' && <>{' '}<small>{p.city}</small></>}<br /><small>{p.country}</small></span>
        <b>{p.code}</b>
      </>
    ),
  };
}

/** Короткая подсказка (сложный маршрут): без города аэропорта */
export function placeItemShort(p: Place): AutocompleteItem {
  return {
    label: `${p.name} (${p.code})`,
    value: p.code,
    node: <><span>{p.name}<br /><small>{p.country || ''}</small></span><b>{p.code}</b></>,
  };
}

/** «Ташкент (TAS)» → «Ташкент» */
export const cleanName = (s: string): string => s.replace(/\s*\([A-Z]{3}\)\s*$/, '').trim();
